import { DateFormatter } from '~/utils/formatters/prtials/date.formatter';
import { NumberFormatter } from '~/utils/formatters/prtials/number.formatter';
import { TextFormatter } from '~/utils/formatters/prtials/text.formatter';

export class Formatters {
  public static readonly number = NumberFormatter;

  public static readonly text = TextFormatter;

  public static readonly date = DateFormatter;

  public static with<T>(partial: 'number', callback: (formatter: typeof NumberFormatter) => T): T;
  public static with<T>(partial: 'text', callback: (formatter: typeof TextFormatter) => T): T;
  public static with<T>(partial: 'date', callback: (formatter: typeof DateFormatter) => T): T;

  public static with(partial: 'number' | 'text' | 'date', callback: (formatter: any) => any) {
    const formattersMap = {
      number: Formatters.number,
      text: Formatters.text,
      date: Formatters.date
    }[partial];

    if (!formattersMap) {
      throw new Error(`Unknown formatter: ${partial}`);
    }

    return callback(formattersMap);
  }
}
